package com.kinoshazam.utils

import io.ktor.http.Url

fun String.parseUrlSafe(): Url? =
    try {
        Url(this)
    } catch (_: Exception) {
        null
    }